import React , {useEffect, useState} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

import { initializeApp } from 'firebase/app';
import { ref as sref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { getFirestore, collection, getDocs, addDoc } from 'firebase/firestore/lite';
import { getStorage } from "firebase/storage";


// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";

import { Link, Redirect, useParams } from "react-router-dom";

import axios from 'axios'

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { PUBLIC_SIGNS } from "../../constants";

const useStyles = makeStyles(styles);

export default function NewUser() {

    const {id} = useParams();

    const [description, setdescription] = React.useState("");
    const [descriptionState, setdescriptionState] = React.useState("");
    const [material_cost, setmaterial_cost] = React.useState("");
    const [labor_cost, setlabor_cost] = React.useState("");
    const [redirctTo, setRedirctTo] = useState(false);
    const [redirctTo_new_user, setRedirctTo_new_user] = useState(false);
    const [token_logged, settoken_logged] = React.useState("");
    const [tc, setTC] = React.useState(false);
    const [Errmessage, setErrmessage] = React.useState("");
    const [codeset_id, setcodeset_id] = React.useState("");
    const [current_image, setcurrent_image] = React.useState("");
    const [force_update, setforce_update] = useState(false);    
    
  
    

    const verifyLength = (value, length) => {
        if (value.length >= length) {
            return true;
        }
        return false;
    };

    

  
  React.useEffect(() => {

      document.getElementById("test_id").innerHTML = "Edit Sign";

      const local_login = localStorage.getItem('local_login')
      let token = "";
      if(local_login){
        try {
        const getToken = async () => {
          const res = await axios.post('/user/refresh_token', null)
          
          token = res.data.access_token;

          settoken_logged(token);

          const res2 = await axios.get('/user/infor', {
            headers: {Authorization: token}
          })     
          console.log( res2.data );

          const res3 = await axios.post('/codeset/infor_signs_edit', {id},{
            headers: {Authorization: token}
          })
          setdescription(res3.data.name)
          setmaterial_cost(res3.data.sign_cost)
          setlabor_cost(res3.data.sign_labor)
          setcodeset_id(res3.data.codeset_id);
          let image_ = ""
          console.log("includes",res3.data.image.includes("firebasestorage"));
          if(res3.data.image.includes("firebasestorage")){
            image_ = res3.data.image;
          }else{
            image_ = PUBLIC_SIGNS + res3.data.image;
          }
          

          setcurrent_image(image_);
          setforce_update(force_update => force_update + 1);
        }
        getToken()
          } catch (err) {
            setRedirctTo(true);
        }
      }else{
        setRedirctTo(true)
      }
    
  }, [  ]);

  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_FIREBASE_APPID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID
  };

  const app = initializeApp(firebaseConfig);
    const db = getFirestore(app);
    const storage = getStorage(app);
  

  const registerClick = async e => {
    
    let valid = 1;
    let image_url = "";
    e.preventDefault();

    if (description === "") {
        setdescriptionState("error");
        valid = 0;
    }

    if(description.length < 6){
        setdescriptionState("error");
        valid = 0;
        setErrmessage("Sing Name Characters Required");
        showNotification(true);
    }
    if(valid === 1){

      try {
        const files = document.getElementById('file1');        
        const file = files.files[0]
        if(file){
          
          let new_name = Math.random().toString(36).substr(2, 9);
          new_name = new_name + file.name;
    
          const storageRef = sref(storage, new_name);
          const uploadTask = uploadBytesResumable(storageRef, file);
    
          const res1 = await uploadTask.on("state_changed",
            (snapshot) => {
              const progress =
                Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
              //setProgresspercent(progress);
            },
            (error) => {
              alert(error);
            },
            () => {
              getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                //setImgUrl(downloadURL)
                console.log(downloadURL);
                image_url = downloadURL;
                save_sign(description,downloadURL,material_cost,labor_cost);
                
              });
            }
          );  
        }else{
          save_sign(description,"",material_cost,labor_cost);
        }
      } catch (err) {

      }

       
    }
    

  };

  async function save_sign(description,image_url,material_cost,labor_cost) {
    try {
      const res = await axios.post('/codeset/update_sign', {
          description, sign_id : id , image_url, material_cost, labor_cost
      })
      console.log(res.data.msg);

      setRedirctTo_new_user(true);
      //setUser({...user, err: '', success: res.data.msg})
    } catch (err) {
        setErrmessage(err.response.data.msg);
        showNotification(true);
        //err.response.data.msg && 
        //setUser({...user, err: err.response.data.msg, success: ''})
    }     
  }

  const classes = useStyles();

  if (redirctTo){
    return <Redirect to='/auth/login-page'  />
  }

  if (redirctTo_new_user){
    return <Redirect to={'/admin/signs/'+ codeset_id}  />
  }


  const showNotification = place => {
    setTC(true);
    setTimeout(function() {
      setTC(false);
    }, 3000);
  };
  
  
  return (
    <div>

      <Snackbar
        place="tc"
        color="rose"
        icon={AddAlert}
        message={Errmessage}
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />
      
      <GridContainer>
          
        <GridItem xs={12} sm={12} md={12}>
            <div className={classes.right}>
                <Link to={'/admin/signs/'+ codeset_id}>
                  <Button color="rose" className={classes.right}>
                      Back to All Cost Items
                  </Button>
                </Link>
                <Button onClick={registerClick} color="rose" className={classes.right}>
                    Save Cost Item
                </Button>
            </div>
          <Card>
            <CardBody>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                            success={descriptionState === "success"}
                            error={descriptionState === "error"}
                            labelText="Cost Item Name"
                            id="name"
                            formControlProps={{
                            fullWidth: true
                            }}
                            inputProps={{
                                onChange: event => {
                                    if (verifyLength(event.target.value, 1)) {
                                        setdescriptionState("success");
                                    } else {
                                        setdescriptionState("error");
                                    }
                                    setdescription(event.target.value);
                                },
                            type: "text",
                            autoComplete: "off",
                            value:description
                            }}
                        />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={4} md={4}>
                    <legend>Image  (.PNG Recommended)</legend>
                    {(current_image != "" ) && (
                    <ImageUpload
                        url={current_image}
                        addButtonProps={{
                        color: "rose",
                        round: true
                        }}
                        changeButtonProps={{
                        color: "rose",
                        round: true
                        }}
                        removeButtonProps={{
                        color: "danger",
                        round: true
                        }}

                    />
                    )}
                    {(current_image == "" ) && (
                      <ImageUpload
                          addButtonProps={{
                          color: "rose",
                          round: true
                          }}
                          changeButtonProps={{
                          color: "rose",
                          round: true
                          }}
                          removeButtonProps={{
                          color: "danger",
                          round: true
                          }}
                      />
                    )}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={2}>
                                Item Cost
                                <CustomInput
                                    id={"material_cost" }
                                    formControlProps={{
                                    fullWidth: true
                                    }}
                                    inputProps={{
                                        onChange: event => {
                                            if (verifyLength(event.target.value, 1)) {
                                                //setdescriptionState("success");
                                            } else {
                                                //setdescriptionState("error");
                                            }
                                            setmaterial_cost(event.target.value);
                                        },
                                      type: "text",
                                      autoComplete: "off",
                                      placeholder: "$0.00",
                                      value:material_cost
                                    }}
                                />
                            </GridItem>    
                            <GridItem xs={12} sm={12} md={2}>
                                Labor Cost
                                <CustomInput
                                    id={"labor_cost"  }
                                    formControlProps={{
                                    fullWidth: true
                                    }}
                                    inputProps={{
                                      onChange: event => {
                                          if (verifyLength(event.target.value, 1)) {
                                              //setdescriptionState("success");
                                          } else {
                                              //setdescriptionState("error");
                                          }
                                          setlabor_cost(event.target.value);
                                      },
                                    type: "text",
                                    autoComplete: "off",
                                    placeholder: "$0.00",
                                    value:labor_cost
                                  }}
                                />
                            </GridItem> 
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            
            </CardBody>
          </Card>
          <div className={classes.right}>
                <Link to={'/admin/signs/'+ codeset_id}>
                  <Button color="rose" className={classes.right}>
                      Back to All Cost Items
                  </Button>
                </Link>
                <Button onClick={registerClick} color="rose" className={classes.right}>
                    Save Cost Item
                </Button>
            </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
